// Module
var code = "<div class=\"ui basic segment\" ng-class=\"{loading : oauth.loading}\"></div>";
// Exports
module.exports = code;